export const categories = [
    {
        name: "relationships.mom",
        descriptionKey: "relationships.descriptions.mom",
        bgColor: "bg-yellow-900/40",
        bgColor2: "bg-red-900",
    },
    {
        name: "relationships.bestFriend",
        descriptionKey: "relationships.descriptions.bestFriend",
        bgColor: "bg-red-900/40",
        bgColor2: "bg-red-700",
    },
    {
        name: "relationships.colleague",
        descriptionKey: "relationships.descriptions.colleague",
        bgColor: "bg-red-700/40",
        bgColor2: "bg-red-500",
    },
    {
        name: "relationships.dad",
        descriptionKey: "relationships.descriptions.dad",
        bgColor: "bg-teal-800/40",
        bgColor2: "bg-green-900",
    },
    {
        name: "relationships.belovedPartner",
        descriptionKey: "relationships.descriptions.belovedPartner",
        bgColor: "bg-teal-600/40",
        bgColor2: "bg-green-700",
    },
    {
        name: "events.birthdayCat",
        descriptionKey: "events.descriptions.birthday",
        bgColor: "bg-emerald-300/40",
        bgColor2: "bg-green-500",
    },
    {
        name: "events.graduationCat",
        descriptionKey: "events.descriptions.graduation",
        bgColor: "bg-orange-400/40",
        bgColor2: "bg-orange-500",
    },
    {
        name: "events.babyShower",
        descriptionKey: "events.descriptions.babyShower",
        bgColor: "bg-orange-300/40",
        bgColor2: "bg-orange-300",
    },
    {
        name: "events.weddingCat",
        descriptionKey: "events.descriptions.wedding",
        bgColor: "bg-red-300/40",
        bgColor2: "bg-red-100",
    },
];
